import { createContext, FC, PropsWithChildren, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { createContextualCan, useAbility } from '@casl/react'
import { getUser } from 'redux/store/user/getters'
import { ability, defineAbility, SavingGoalsAbility } from '../Abilities'
import { AnyAbility } from '@casl/ability'

export const SavingGoalsAbilityContext =
  createContext<SavingGoalsAbility>(ability)

const SavingGoalsAbilityProvider: FC<PropsWithChildren> = ({ children }) => {
  const user = useSelector(getUser)

  const ability = useMemo(() => defineAbility(user), [user])

  return (
    <SavingGoalsAbilityContext.Provider value={ability}>
      {children}
    </SavingGoalsAbilityContext.Provider>
  )
}

export const useSavingGoalsAbility = () =>
  useAbility<SavingGoalsAbility>(SavingGoalsAbilityContext)

export const Can = createContextualCan<AnyAbility>(
  SavingGoalsAbilityContext.Consumer
)

export default SavingGoalsAbilityProvider
